export default "__VITE_ASSET__DD99eGbJ__"